import React from "react";
import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Icon from "@material-ui/core/Icon";
import {Formik, Form, Field} from 'formik';
// @material-ui/icons
import People from "@material-ui/icons/People";
import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-dashboard-react/views/loginPage.js";
import userProfileFormInitialValue from "../UserProfile/FormModel/userProfileFormInitialValue";

const useStyles = makeStyles(styles);

export default function LoginPage(props) {
    const formId = "loginForm";
    const initialValues = {
        username: "demo",
        pass: "demo123456"
    };
    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    setTimeout(function() {
        setCardAnimation("");
    }, 700);
    const classes = useStyles();
    //const { ...rest } = props;

    function handleSubmit(values, actions) {

    }
    return (
        <div style={{width: "100%"}}>

            <div
                className={classes.pageHeader}
            >
                <div className={classes.container}>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                    >
                        {({isSubmitting}) => (
                            <Form id={formId} className={classes.form}>
                                <GridContainer justify="center">
                                    <GridItem xs={12} sm={12} md={4}>
                                        <Card className={classes[cardAnimaton]}>
                                            <CardHeader color="primary" className={classes.cardHeader}>
                                                <h4>Login</h4>
                                            </CardHeader>
                                            <CardBody>
                                                <Field
                                                    component={CustomInput}
                                                    labelText="Username"
                                                    name="username"
                                                    id="username"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        type: "text",
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <People className={classes.inputIconsColor} />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                                <Field
                                                    component={CustomInput}
                                                    labelText="Password"
                                                    name="pass"
                                                    id="pass"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        type: "password",
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <Icon className={classes.inputIconsColor}>
                                                                    lock_outline
                                                                </Icon>
                                                            </InputAdornment>
                                                        ),
                                                        autoComplete: "off"
                                                    }}
                                                />
                                            </CardBody>
                                            <CardFooter className={classes.cardFooter}>
                                                <Button component={Link} to="/admin/dashboard" color="primary" size="lg">
                                                    Login Now
                                                </Button>
                                            </CardFooter>
                                            <CardFooter className={classes.cardFooterOther}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            tabIndex={-1}
                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                            classes={{
                                                                checked: classes.checked,
                                                                root: classes.checkRoot
                                                            }}
                                                        />
                                                    }
                                                    classes={{ label: classes.label, root: classes.labelRoot }}
                                                    label="Remember me"
                                                />
                                            </CardFooter>
                                            <CardFooter className={classes.cardFooterOther}>
                                                <hr style={{width: "100%"}}/>
                                            </CardFooter>
                                            <CardFooter className={classes.cardFooterOther} style={{paddingBottom: "15px"}}>
                                                <a href="/" style={{color: "blue"}}>Forgot Password?</a>
                                            </CardFooter>
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
}
